import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiRequest } from '../api';
import { queryKeys } from '../queryKeys';
import type { Reviewer } from '../types';

export function useReviewers() {
  return useQuery({
    queryKey: queryKeys.reviewers,
    queryFn: () => apiRequest<Reviewer[]>('/api/reviewers'),
  });
}

export function useCreateReviewer() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { name: string; email?: string }) =>
      apiRequest<Reviewer>('/api/reviewers', { method: 'POST', body: input }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.reviewers }),
  });
}

export function useUpdateReviewer() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch }: { id: number; patch: Partial<Reviewer> }) =>
      apiRequest<Reviewer>(`/api/reviewers/${id}`, { method: 'PATCH', body: patch }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.reviewers }),
  });
}

export function useDeleteReviewer() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => apiRequest<void>(`/api/reviewers/${id}`, { method: 'DELETE' }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.reviewers }),
  });
}
